import { render, staticRenderFns } from "./GiveRewards.vue?vue&type=template&id=5ac50be8&scoped=true"
import script from "./GiveRewards.vue?vue&type=script&lang=js"
export * from "./GiveRewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac50be8",
  null
  
)

export default component.exports